<template>
  <v-data-table
    :headers="headers"
    :loading="!!!inhabitantHistory"
    :items="inhabitantHistory"
    :items-per-page="10"
  >
    <template v-slot:item.date_from="{ item }">
      {{ item.date_from | dateFormat }}
    </template>

    <template v-slot:item.date_to="{ item }">
      {{ item.date_to | dateFormat }}
    </template>
  </v-data-table>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'InhabitantHistoryPage',

  filters: {
    dateFormat
  },

  props: {
    person: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    inhabitantHistory: []
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex_name'
        },
        {
          text: this.$t('BUILDINGS.ITEM'),
          value: 'building_name'
        },
        {
          text: this.$t('APARTMENTS.ITEM'),
          value: 'apartment_name'
        },
        {
          text: this.$t('INHABITANTS.DATE_FROM'),
          value: 'date_from'
        },
        {
          text: this.$t('INHABITANTS.DATE_TO'),
          value: 'date_to'
        },
        {
          text: this.$t('ITEM.ADDITIONAL_INFO'),
          value: 'info'
        }
      ];
    }
  },

  watch: {
    person: {
      handler: 'getHistory'
    }
  },

  created() {
    this.getHistory();
  },

  methods: {
    getHistory() {
      this.$store
        .dispatch('person/retrieveInhabitantHistory', this.person.id)
        .then(({ data }) => {
          this.inhabitantHistory = data;
        });
    }
  }
};
</script>
